

import userStore from "@/store/user";
import layoutStore from "@/store/layout";
import { AbilityTuple, MongoAbility, MongoQuery } from "@casl/ability";
import { NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded } from "vue-router";
import * as Sentry from "@sentry/vue";

export const ROTAS_IGNORADAS = ["/404", "/403", "/acessoFederado", "/login"];
// TODO: AINDA NÃO FIQUEI FELIZ COM ESSA FUNÇÃO, ELA FAZ DUAS COISAS VERIFICAR ACESSO E REDIRECIONAR, DEVERIA APENAS VERIFICAR
export function verificarAcesso(pathsAbertos: any[], to: any, next: any) {
  if (pathsAbertos.includes(to.path)) return true;

    let user = null;
    try {
      user = userStore().user;
    
      if (!user.email) {
        const query = to.query.redirect ? `?redirect=${to.query.redirect}` : "";
        next(`/login${query}`);
        return false;
      }


      Sentry.setUser({
        roles: user.roles,
        email: user.email,
        tipo: user.tipo,
        empresa: user.empresa, // Útil se você usa nicknames como 'CaioPK'
        ip_address: "{{auto}}",   // O Sentry captura o IP automaticamente para geolocalização
      });

      if (to.params.obra)
        return possuiAcesso(to.meta.subject, to.meta.action, to.params.obra)

      if (possuiAcesso(to.meta.subject, to.meta.action)) return true;

      next("/403");

    } catch (e) {
      next("/403");
      return false;
    }
  
}
// TODO: AINDA FALTA REFATORAR ESSE
export function possuiAcesso(
  rolesNecessarios: any,
  acoes = [],
  obra: any = []
) {
  const userAbility = userStore().ability as MongoAbility<
    AbilityTuple,
    MongoQuery
  >;
  if (rolesNecessarios && rolesNecessarios.length) {
    let liberado = false;
    let i = 0;
    
    do {
      if (acoes.length) {
        for (const acao of acoes) {
          
          liberado = userAbility.can(acao, rolesNecessarios[i]);
        }
      } else {
        liberado = userAbility.can("read", rolesNecessarios[i]);
      }
      i = i + 1;
    } while (!liberado && i < rolesNecessarios.length);
    return liberado;
  }
  return true;
}

let layout: any = null;
// TODO: AINDA FALTA REFATORAR ESSE
export async function criarBreadcrumbs(rota: any) {
  try {
    
    if (layout == null) {
      layout = layoutStore();
    }

    let crumbs: any[] = ["Home"];
    rota.matched.forEach((el: any) => {
      if (["Home"].includes(el.name)) {
        return;
      }
      if (el.meta.breadcrumb) {
        const todosPaths = el.meta.breadcrumb.split("|");
        crumbs = crumbs.concat(todosPaths);
      }
      crumbs.push(el.name);
    });
    const crumbTratado = crumbs.filter((e) => e);
    await layout.setBreadcrumbs(crumbTratado);
  } catch (e) {
    console.error("Erro ao criar breadcrumbs", e);
  }
}

function n_nulo(obj: any) {
  return (
    obj &&
    Object.keys(obj).length !== 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

export function converterHashFederado(to: RouteLocationNormalized, next: NavigationGuardNext) {
  if (to.path == "/acessoFederado" && !!to.hash) {
    const novoPath = `/acessoFederado?${to.hash.substring(1)}`;
    next(novoPath);
    return;
  }
}

export function filtrarRotasSeNecessario(from: RouteLocationNormalized, START_LOCATION: RouteLocationNormalizedLoaded) {
  if (
    from === START_LOCATION ||
    (from &&
      ["Login", "AcessoFederado", "PrimeiroAcesso"].includes(
        from.name as string
      ))
  ) {
    layoutStore().filtrarRotasComAcesso();
  }
}

export function redirecionarUltimaRota(from: RouteLocationNormalized, to: RouteLocationNormalized, next: NavigationGuardNext) {
  if (from.name && ["AcessoFederado"].includes(from.name as string)) {
    const store = userStore();
    if (store.ultimaRotaVisitada && !to.redirectedFrom) {
      
      if (to.path !== store.ultimaRotaVisitada) {
        if (store.ultimaRotaVisitada.includes("?")){
          next({
            path: store.ultimaRotaVisitada.split("?")[0],
            query: Object.fromEntries(
              new URLSearchParams(store.ultimaRotaVisitada.split("?")[1])
            ),
          });
        }
        else next({ path: store.ultimaRotaVisitada });
        return true;
      }
    }
  }
  return false
}